import { render, staticRenderFns } from "./kpiProjectTable.vue?vue&type=template&id=0bae9e70"
import script from "./kpiProjectTable.vue?vue&type=script&lang=js"
export * from "./kpiProjectTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports